import {
  IntakeSectionHeader,
  StyledGridCol,
  StyledGridRow,
} from "@/common/styles";
import Button from "@/common/elements/Button";
import { useState, useEffect, forwardRef, useImperativeHandle } from "react";
import Modal from "@/common/elements/Modal";
import Table from "@/common/elements/Table";
import { BookingsSectionTitle } from "./styles";
import FormItem from "@/common/elements/InputElements/FormItem.jsx";
import CommonDatePicker from "@/common/elements/DatePicker";
import { Col, Row } from "react-bootstrap";
import { Checkbox, Form } from "antd";
import TextField from "@/common/elements/InputElements/TextField";
import TimePicker from "@/common/elements/TimePicker";
import { useDispatch, useSelector } from "react-redux";
import {
  getOptionsFromRefList,
  getRefListNameByID,
  hasCheckSecurity,
  isNonEmptyVariable,
} from "@/util/common_function";
import dayjs from "dayjs";
import { setBookings, setDeleteAPis } from "@/slices/bookingsSlice";
import { v4 as uuidv4 } from "uuid";
import API_ENDPOINTS from "@/util/api";
import { Entity_types, Security_Types } from "@/util/permission_bits";
import { LABELS_CAPITAL } from "@/util/usePermissionMask";
import {
  MODULES_LIST_WITH_ID,
  SUB_MODULES_LIST_WITH_ID,
} from "@/util/common_variable";

const MedicalAuthorizationsTable = {
  headers: [
    { key: "authorizedBy", text: "Authorized By" },
    { key: "authorizedOn", text: "Authorized On" },
    { key: "expirationDate", text: "Expires On" },
    { key: "comments", text: "Comments" },
  ],
  rows: [],
};

const MedicalAuthorizationsDetails = forwardRef(
  ({ medicalAuthorizationsDetailsRef }, ref) => {
    const dispatch = useDispatch();
    const { bookings, bookingsFieldsEnabled } = useSelector(
      (state) => state?.bookings
    );
    const [medicalAuth, setMedicalAuth] = useState(
      bookings?.medicalAuthorizations
    );
    useEffect(() => {
      console.log({ medicalAuth })
    }, [medicalAuth])
    const [showMedicalAuthorizations, setShowMedicalAuthorizations] =
      useState(false);
    const [editMedicalAuth, setEditMedicalAuth] = useState(false);
    const [selectedRow, setSelectedRow] = useState();
    const [originalRow, setOriginalRow] = useState();
    const [medicalId, setMedicalId] = useState(null);
    const [checkedItems, setCheckedItems] = useState({});
    const [medicalAuthForm] = Form.useForm();
    const [isEdit, setisEdit] = useState(false);
    const [isDisabled, setIsDisabled] = useState(false);
    const currentUser = JSON.parse(localStorage.getItem("userDetails"));

    useEffect(() => {
      if (bookings?.medicalAuthorizations?.length > 0) {
        let updatedAuths = bookings?.medicalAuthorizations.map((auth) => ({
          ...auth,
          medicalAuthorizationID: auth.medicalAuthorizationID
            ? auth.medicalAuthorizationID
            : uuidv4(),
        }));
        setMedicalAuth(updatedAuths);

        let initialCheckedState = {};
        updatedAuths.forEach((auth) => {
          initialCheckedState[auth.medicalAuthorizationID] =
            auth.medicalAuthorizationSpecific
              ? auth.medicalAuthorizationSpecific.reduce((acc, spec) => {
                acc[spec.authorizationId] = true;
                return acc;
              }, {})
              : {};
        });
        setCheckedItems(initialCheckedState);
      } else {
        setMedicalAuth([]);
        setCheckedItems({});
      }
    }, [bookings]);

    useEffect(() => {
      console.log({ selectedRow })
      medicalAuthForm.setFieldsValue(selectedRow);
    }, [selectedRow]);

    const handleSpecChange = (authorizationId) => {
      if (!selectedRow) return;
      const currentSpecs = selectedRow.medicalAuthorizationSpecific
        ? [...selectedRow.medicalAuthorizationSpecific]
        : [];
      const index = currentSpecs.findIndex(
        (spec) => spec.authorizationId === Number(authorizationId)
      );
      if (index >= 0) {
        const removedSpec = currentSpecs[index];
        console.log(removedSpec);
        if (removedSpec.medicalAuthorizationSpecificID) {
          const url =
            API_ENDPOINTS.medicalAuthorizationsSpecific +
            removedSpec.medicalAuthorizationSpecificID;
          dispatch(setDeleteAPis(url));
        }
        currentSpecs.splice(index, 1);
      } else {
        let specToAdd = {
          medicalAuthorizationSpecificID: null,
          medicalAuthorizationID: null,
          authorizationId: Number(authorizationId),
        };
        if (originalRow && originalRow.medicalAuthorizationSpecific) {
          const orig = originalRow.medicalAuthorizationSpecific.find(
            (spec) => spec.authorizationId === Number(authorizationId)
          );
          if (orig) {
            specToAdd = orig;
          }
        }
        currentSpecs.push(specToAdd);
      }
      setSelectedRow({
        ...selectedRow,
        medicalAuthorizationSpecific: currentSpecs,
      });
    };

    // New handler for Isolation changes
    const handleIsolationChange = (isolationId) => {
      if (!selectedRow) return;
      const currentIsolations = selectedRow.medicalAuthorizationIsolation
        ? [...selectedRow.medicalAuthorizationIsolation]
        : [];
      const index = currentIsolations.findIndex(
        (item) => item.isolationID === Number(isolationId)
      );

      if (index >= 0) {
        const removedIsolation = currentIsolations[index];
        if (removedIsolation.medicalAuthorizationIsolationID) {
          const url =
            API_ENDPOINTS.medicalAuthorizationIsolation +
            removedIsolation.medicalAuthorizationIsolationID;
          dispatch(setDeleteAPis(url));
        }
        currentIsolations.splice(index, 1);
      } else {
        let isolationToAdd = {
          medicalAuthorizationIsolationID: null,
          medicalAuthorizationID: null,
          isolationID: Number(isolationId),
        };
        if (originalRow && originalRow.medicalAuthorizationIsolation) {
          const orig = originalRow.medicalAuthorizationIsolation.find(
            (item) => item.isolationID === Number(isolationId)
          );
          if (orig) {
            isolationToAdd = orig;
          }
        }
        currentIsolations.push(isolationToAdd);
      }
      setSelectedRow({
        ...selectedRow,
        medicalAuthorizationIsolation: currentIsolations,
      });
    };

    const handleAddMedicalAuth = () => {
      const newId = uuidv4();
      medicalAuthForm.resetFields();
      // Initialize both specific and isolation arrays as empty
      setSelectedRow({
        medicalAuthorizationID: newId,
        medicalAuthorizationSpecific: [],
        medicalAuthorizationIsolation: [],
      });
      setOriginalRow(null);
      setMedicalId(null);
      setShowMedicalAuthorizations(true);
    };

    const closeModal = () => {
      setShowMedicalAuthorizations(false);
      setisEdit(false);
    };

    const handleEditMedicalAuth = (val) => {
      setShowMedicalAuthorizations(true);
      if (val == "edit") {
        setisEdit(true);
      }
    };

    const selectedMedicalRow = (selectedRowData) => {
      const rowId = selectedRowData?.medicalAuthorizationID;
      if (!rowId) {
        console.warn("Warning: Selected row has no ID!", selectedRowData);
      }
      setOriginalRow({ ...selectedRowData });
      setSelectedRow({
        ...selectedRowData,
        medicalAuthorizationID: rowId,
        expireDate: isNonEmptyVariable(selectedRowData?.expirationDate)
          ? dayjs(selectedRowData?.expirationDate)
          : null,
        comments: selectedRowData?.comments || "",
        // Ensure isolation array is initialized
        medicalAuthorizationIsolation:
          selectedRowData?.medicalAuthorizationIsolation || [],
        dateAddedAudit: isNonEmptyVariable(selectedRowData?.dateAdded) ? dayjs(`${selectedRowData.dateAdded} ${selectedRowData.timeAdded}`) : null,
        creatorStaff:isNonEmptyVariable(selectedRowData?.creatorStaffID)?getRefListNameByID("",selectedRowData?.creatorStaffID,true):""
      });
      setMedicalId(rowId);
      setEditMedicalAuth(true);
    };

    const handleSave = () => {
      medicalAuthForm
        .validateFields()
        .then((values) => {
          values.expirationDate = isNonEmptyVariable(values.expireDate)
            ? dayjs(values.expireDate).format("MM/DD/YYYY")
            : null;
          values.dateAdded = isNonEmptyVariable(values.dateAddedAudit)
            ? dayjs(values.dateAddedAudit).format("MM/DD/YYYY")
            : null;
          values.timeAdded = isNonEmptyVariable(values.dateAddedAudit)
            ? dayjs(values.dateAddedAudit).format("HH:mm")
            : null;
          values.creatorStaffID=currentUser?.staffId
          delete values?.expireDate;
          delete values?.dateAddedAudit;
          // delete values?.timeAddedAudit;

          setCheckedItems((prevCheckedItems) => {
            let updatedData;
            if (medicalId) {
              updatedData = medicalAuth?.map((ma) =>
                ma?.medicalAuthorizationID === medicalId
                  ? {
                    ...ma,
                    ...values,
                    medicalAuthorizationSpecific:
                      selectedRow.medicalAuthorizationSpecific || [],
                    medicalAuthorizationIsolation:
                      selectedRow.medicalAuthorizationIsolation || [],
                  }
                  : ma
              );
            } else {
              updatedData = [
                ...medicalAuth,
                {
                  ...values,
                  medicalAuthorizationID: selectedRow.medicalAuthorizationID,
                  medicalAuthorizationSpecific:
                    selectedRow.medicalAuthorizationSpecific || [],
                  medicalAuthorizationIsolation:
                    selectedRow.medicalAuthorizationIsolation || [],
                },
              ];
            }
            updateBookings(updatedData);
            setShowMedicalAuthorizations(false);
            setEditMedicalAuth(false);
            return prevCheckedItems;
          });
        })
        .catch((err) => console.log("Validation error:", err));
    };

    const updateBookings = (tb) => {
      console.log("Updating bookings with:", tb);
      const uuidRegex =
        /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;
      const updatedMedicalAuthorizations = tb.map((auth) => {
        const actualAuthID = uuidRegex.test(auth.medicalAuthorizationID)
          ? null
          : auth.medicalAuthorizationID;
        return {
          ...auth,
          medicalAuthorizationID: actualAuthID || null,
          medicalAuthorizationSpecific: auth.medicalAuthorizationSpecific || [],
          medicalAuthorizationIsolation:
            auth.medicalAuthorizationIsolation || [],
        };
      });
      console.log(
        "Updated medicalAuthorizations:",
        updatedMedicalAuthorizations
      );
      dispatch(
        setBookings({
          medicalAuthorizations: updatedMedicalAuthorizations,
        })
      );
    };

    useImperativeHandle(medicalAuthorizationsDetailsRef, () => ({
      submitForm: () => medicalAuthForm.submit(),
      resetForm: () => medicalAuthForm.resetFields(),
      getFormValues: () => {
        return medicalAuthForm.getFieldsValue();
      },
      getFieldsError: () => medicalAuthForm.getFieldsError(),
      isFieldsValidating: () => medicalAuthForm.isFieldsValidating(),
      validateFields: () => medicalAuthForm.validateFields(),
    }));
    useEffect(() => {
      if (isEdit) {
        let isShow = hasCheckSecurity(
          Security_Types.functionality,
          Entity_types.subModule,
          LABELS_CAPITAL.MODIFY,
          MODULES_LIST_WITH_ID.MODULE_BOOKINGS,
          SUB_MODULES_LIST_WITH_ID.Inmate_Medical
        );
        if (isShow) {
          setIsDisabled(false);
        } else {
          setIsDisabled(true);
        }
      } else {
        setIsDisabled(false);
      }
    }, [isEdit]);
    useEffect(() => {
      console.log({ isDisabled });
    }, [isDisabled]);
    return (
      <>
        <StyledGridRow justify={"space-between"}>
          <StyledGridCol>
            <Button
              onClick={handleAddMedicalAuth}
              disabled={
                !bookingsFieldsEnabled ||
                !hasCheckSecurity(
                  Security_Types.functionality,
                  Entity_types.subModule,
                  LABELS_CAPITAL.ADD,
                  MODULES_LIST_WITH_ID.MODULE_BOOKINGS,
                  SUB_MODULES_LIST_WITH_ID.Inmate_Medical
                )
              }
            >
              ADD
            </Button>
          </StyledGridCol>
          <StyledGridCol>
            <Button
              style={{ marginRight: "10px" }}
              disabled={
                !bookingsFieldsEnabled ||
                !editMedicalAuth ||
                !hasCheckSecurity(
                  Security_Types.functionality,
                  Entity_types.subModule,
                  LABELS_CAPITAL.VIEW,
                  MODULES_LIST_WITH_ID.MODULE_BOOKINGS,
                  SUB_MODULES_LIST_WITH_ID.Inmate_Medical
                )
              }
              onClick={() => handleEditMedicalAuth("edit")}
            >
              Details
            </Button>

            <Button disabled={!bookingsFieldsEnabled || !editMedicalAuth}>
              Config
            </Button>
          </StyledGridCol>
        </StyledGridRow>

        <Modal
          header={"Medical Authorizations"}
          show={showMedicalAuthorizations}
          size="xl"
          onHide={closeModal}
          footerActions={[
            {
              key: "save",
              text: "Save",
              onClick: handleSave,
              disabled: isDisabled,
            },
          ]}
          footerCloseAction={() => setisEdit(false)}
          footerCloseActionText="Close"
        >
          <Form form={medicalAuthForm} disabled={!bookingsFieldsEnabled}>
            <BookingsSectionTitle
              style={{ marginBottom: "10px", marginTop: "15px" }}
            >
              <span>Authorization Information</span>
            </BookingsSectionTitle>
            <StyledGridRow gutter={16}>
              <StyledGridCol lg={6}>
                <FormItem name="expireDate" label="Expiration Date">
                  <CommonDatePicker format="MM/DD/YYYY" showTime={false} />
                </FormItem>
              </StyledGridCol>
            </StyledGridRow>

            <BookingsSectionTitle
              style={{ marginBottom: "10px", marginTop: "15px" }}
            >
              <span>Specific Authorization(s)</span>
            </BookingsSectionTitle>

            <StyledGridRow>
              {getOptionsFromRefList(
                "Medical_Authorizations",
                false,
                false,
                true
              ).map((medical, i) => {
                const isChecked = selectedRow?.medicalAuthorizationSpecific
                  ? selectedRow.medicalAuthorizationSpecific.some(
                    (spec) => spec.authorizationId === Number(medical.value)
                  )
                  : false;
                if (i !== 0)
                  return (
                    <StyledGridCol span={6} key={medical.value}>
                      <FormItem
                        label={medical.label}
                        layout="horizontal"
                        labelPostion="label-right"
                      >
                        <Checkbox
                          checked={isChecked}
                          onChange={() => handleSpecChange(medical.value)}
                        />
                      </FormItem>
                    </StyledGridCol>
                  );
              })}
            </StyledGridRow>

            <BookingsSectionTitle
              style={{ marginBottom: "10px", marginTop: "15px" }}
            >
              <span>Isolation Authorization(s)</span>
            </BookingsSectionTitle>

            <StyledGridCol>
              <StyledGridRow gutter={16}>
                {getOptionsFromRefList(
                  "Medical_Isolation",
                  false,
                  false,
                  true
                ).map((med, i) => {
                  const isChecked = selectedRow?.medicalAuthorizationIsolation
                    ? selectedRow.medicalAuthorizationIsolation.some(
                      (item) => item.isolationID === Number(med.value)
                    )
                    : false;
                  if (i !== 0)
                    return (
                      <StyledGridCol span={8} key={med.value}>
                        <FormItem
                          label={med.label}
                          layout="horizontal"
                          labelPostion="label-right"
                        >
                          <Checkbox
                            checked={isChecked}
                            onChange={() => handleIsolationChange(med.value)}
                          />
                        </FormItem>
                      </StyledGridCol>
                    );
                })}
              </StyledGridRow>
            </StyledGridCol>

            <Col span={8}>
              <FormItem name="comments" label="Comments">
                <TextField
                  inputType="textarea"
                  as="textarea"
                  id="description"
                  name="description"
                  variant="outlined"
                  rows="5"
                />
              </FormItem>
            </Col>

            <IntakeSectionHeader>
              <span>Administrative Information</span>
            </IntakeSectionHeader>

            <StyledGridRow gutter={16}>
              <StyledGridCol lg={3}>
                <FormItem label="ID" layout="vertical" name="medicalAuthorizationId" >
                  <TextField disabled />
                </FormItem>
              </StyledGridCol>
              <StyledGridCol lg={4}>
                <FormItem label="Date Entered" layout="vertical" name="dateAddedAudit" >
                  <CommonDatePicker id="dateEntered" />
                </FormItem>
              </StyledGridCol>
              {/* <StyledGridCol lg={4}>
                <FormItem label="Time Entered" layout="vertical" name="timeAddedAudit" >
                  <TimePicker />
                </FormItem>
              </StyledGridCol> */}
              <StyledGridCol lg={6}>
                <FormItem label="User" layout="vertical"  name="creatorStaff">
                  <TextField disabled/>
                </FormItem>
              </StyledGridCol>
            </StyledGridRow>
          </Form>
        </Modal>

        {hasCheckSecurity(
          Security_Types.functionality,
          Entity_types.subModule,
          LABELS_CAPITAL.VIEW,
          MODULES_LIST_WITH_ID.MODULE_BOOKINGS,
          SUB_MODULES_LIST_WITH_ID.Inmate_Medical
        ) && (
            <Table
              headers={MedicalAuthorizationsTable.headers}
              data={medicalAuth?.map((auth) => ({
                medicalAuthorizationID: auth.medicalAuthorizationID,
                expirationDate: auth?.expirationDate || "",
                comments: auth?.comments || "",
                medicalAuthorizationSpecific: auth.medicalAuthorizationSpecific, // include specifics
                medicalAuthorizationIsolation: auth.medicalAuthorizationIsolation, // include isolation payload
                dateAdded: auth.dateAdded,
                timeAdded: auth.timeAdded,
                medicalAuthorizationId: auth?.medicalAuthorizationID,
                creatorStaffID:auth?.creatorStaffID
              }))}
              onRowClick={(data) => selectedMedicalRow(data)}
              style={{ marginTop: "15px" }}
              selected={selectedRow === null}
            />
          )}
      </>
    );
  }
);
export default MedicalAuthorizationsDetails;
